import React from 'react';
import { UniskaiFormFooterRef } from 'templates/form/uniskai-form-footer';
import { UniskaiFormHeaderRef } from 'templates/form/uniskai-form-header';

type UniskaiFormTemplateContextType = {
  totalRef: React.RefObject<UniskaiFormFooterRef>;
  titleRef: React.RefObject<UniskaiFormHeaderRef>;
};

const UniskaiFormTemplateContext =
  React.createContext<UniskaiFormTemplateContextType>({
    titleRef: { current: null },
    totalRef: { current: null },
  });

export interface UniskaiFormTemplateProviderProps {
  children: (values: UniskaiFormTemplateContextType) => React.ReactNode;
  titleRef?: React.RefObject<UniskaiFormHeaderRef>;
  totalRef?: React.RefObject<UniskaiFormFooterRef>;
}

export default function UniskaiFormTemplateProvider(
  props: UniskaiFormTemplateProviderProps,
) {
  const { children } = props;
  const totalRef = React.useRef<UniskaiFormFooterRef>(null); // to change total
  const titleRef = React.useRef<UniskaiFormHeaderRef>(null); // to change title

  const values = React.useMemo(() => {
    return {
      totalRef: props.totalRef ?? totalRef,
      titleRef: props.titleRef ?? titleRef,
    };
  }, [props.titleRef, props.totalRef]);

  return (
    <UniskaiFormTemplateContext.Provider value={values}>
      {children(values)}
    </UniskaiFormTemplateContext.Provider>
  );
}

export function useUniskaiFormTemplateContext() {
  const context = React.useContext(UniskaiFormTemplateContext);
  return context;
}
